export const initialState = {
  links: {},
  actionProcessing: false,
};
